import { useState, useEffect, useCallback } from 'react';
import { UserPath } from '../types/UserPath';
import { getCachedPathForUser, refreshPathForUser } from '../services/userPathService';
import { useAuth } from '@/contexts/AuthContext';

export const usePersonalizedPath = () => {
  const { user, loading: authLoading } = useAuth();
  const [path, setPath] = useState<UserPath | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (authLoading) return;
    setError(null);

    try {
      const resolvedPath = await refreshPathForUser(user?.id);
      setPath(resolvedPath);
    } catch (err) {
      console.error('Failed to load personalized path:', err);
      setError('Failed to load path');
    }
  }, [user?.id, authLoading]);

  useEffect(() => {
    if (authLoading) return;
    const cachedPath = getCachedPathForUser(user?.id);
    setPath(cachedPath);
    setLoading(false);
    void refresh();
  }, [authLoading, user?.id, refresh]);

  return { path, loading: loading || authLoading, error, refetch: refresh };
};
